export default {
  baseUrl: "https://hrapp.tyjfwy.com",
  domain: "https://hrapi.tyjfwy.com",
  token : '',
  appid: "wxa5d32200e0692c5f",
  imgURL:'http://hrapi.tyjfwy.com/public/uploads',
  backUrl : 'http://hrapi.tyjfwy.com' //后台地址，用于展示图片
};